import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_META_PIXEL_STATE_BLOCKLIST = defineFcm('meta_pixel_state_blocklist')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: { type: 'string' },
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { countries: true },
		description:
			'List of uppercase state codes where the Meta Pixel is blocked from loading, configurable per country.',
		import: false,
		template: ['CA', 'NY', 'MA'],
	});
